import { css } from 'emotion';

export const placeholder = css`
  max-width: 267px;
  display: flex;
  flex-direction: column;
`;

export const buttonStyle = css`
  display: flex;
  justify-content: center;

  > button {
    min-width: 160px;
    white-space: nowrap;
  }
`;

export const addIcon = css`
  transform: scale(1.5);
`;
